
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ElementsModule } from '../../ui/elements/elementsModule';
import { UserRegistrationComponent } from './userRegistration/userRegistrationComponent';

@NgModule({
    imports: [
        CommonModule,
        ElementsModule,
        FormsModule
    ],
    declarations: [
        UserRegistrationComponent
    ]
})
export class PreLoginComponentsModule {}



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/componentsModule.ts